export const selectReport = ({ TMPlan_reducer }) => {
    return TMPlan_reducer.report;
};
export const IsClientInUK = ({ MainReducer }) => {
    let profile = MainReducer.profile;
    if (profile) {
        if (profile.title.includes("ProworkUK")) {
            return true;
        } else return false;
    }
};
export const clientDetails = ({ MainReducer }) => {
    let profile = MainReducer.profile;
    if (profile) {
        return profile
    }
    return false
};